"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _set = _interopRequireDefault(require("./partition/set.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Columns = /*#__PURE__*/function () {
  function Columns(container) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Columns);

    this.container = container;
    this.options = _objectSpread({
      columns: 1,
      breakpoints: null,
      column_class: 'column-js',
      algorithm: 'greedy'
    }, options);
    this.set = new _set["default"](Array.from(this.container.children) || [], {
      algorithm: this.options.algorithm,
      extractor: function extractor(i) {
        return i.getBoundingClientRect().height;
      }
    });
    this.render();
  }

  _createClass(Columns, [{
    key: "count",
    value: function count() {
      var columnCount = this.options.columns;
      var windowWidth = window.innerWidth;
      Object.entries(this.options.breakpoints || {}).some(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            breakpoint = _ref2[0],
            count = _ref2[1];

        if (windowWidth < breakpoint) {
          return true;
        }

        columnCount = count;
      });
      return columnCount;
    }
  }, {
    key: "append",
    value: function append(element) {
      // Temporary append element to the first column
      // to be able to calculate height
      this.container.children[0].append(element);
      var column = this.set.append(element);
      this.container.children[column].append(element);
      return this;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$container;

      var count = this.count();

      var columns = this._prepareColumns(count);

      this.set.partition(count).forEach(function (c, i) {
        var _columns$i;

        return (_columns$i = columns[i]).append.apply(_columns$i, _toConsumableArray(c.lean()));
      });
      this.container.dataset.columns = count;

      while (this.container.firstChild) {
        this.container.removeChild(this.container.firstChild);
      }

      (_this$container = this.container).append.apply(_this$container, _toConsumableArray(columns));

      return this;
    }
  }, {
    key: "setOptions",
    value: function setOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.options = _objectSpread(_objectSpread({}, this.options), options);
    }
  }, {
    key: "_prepareColumns",
    value: function _prepareColumns(count) {
      var _this = this;

      var columns = [];

      _toConsumableArray(Array(count)).forEach(function () {
        var column = document.createElement('div');
        column.classList.add(_this.options.column_class);
        columns.push(column);
      });

      return columns;
    }
  }]);

  return Columns;
}();

exports["default"] = Columns;